import React from 'react'
import style from './articles.style'

const RazmetkaUtmMetok = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Разметка UTM-меток</h2>
      <p>
        Правильная utm-разметка позволят вам отслеживать эффективность рекламы
        до кампаний и ключевых слов.
      </p>
      <p>
        <strong>У ROMI center все 3 обязательные метки:</strong>
      </p>
      <ul className={classes.articleList}>
        <li>
          <strong>Utm_source</strong> — источник перехода (yandex, google).
        </li>
        <li>
          <strong>Utm_medium</strong> — тип рекламного канала (cpc, cpm, email,
          affiliate).
        </li>
        <li>
          <strong>Utm_campaign</strong> — рекламная кампания.
        </li>
      </ul>
      <p>
        Ключевым параметром utm-метки ROMI center, является{' '}
        <strong>utm_source. Utm_source</strong>необходимо оказывать для каждой
        рекламной площадки (Яндекс, Google, Facebook и т.д.) в точном
        соответствии с примерами ниже. Наша система ищет utm-метки и соотносит
        рекламные расходы с показами.
      </p>

      <p>
        Важно! В системе ROMI center зашиты четкие правила определения
        utm-меток. Если у вас указана другая метка <strong>utm_source</strong>,
        то система не сможет определить рекламный канал. Пример. Требование к
        метка Яндекса выглядит следующим образом: “utm_source=yandex”, если вы
        напишите <strong>“utm_source=yandex.ru”</strong> или “utm_source=yad”
        ROMI center не сможет понять к какому рекламному каналу относятся эти
        рекламные расходы.{' '}
      </p>
      <p>
        Не забывайте, что в рекламных кампаниях: Яндекс, Google и MyTarget есть
        обязательный параметр позволяющий определить по какому ключевому слову
        пришел посетитель. Для Яндекс и Google это{' '}
        <strong>{`utm_term={keyword}`}</strong>. Для MyTarget{' '}
        <strong>
          utm_term=
          {`{{ search_phrase }}`}
        </strong>
        .
      </p>
      <p>Так же в utm-метки можно добавлять собственные параметры.</p>

      <h3>Требования к меткам.</h3>

      <div>
        Важно!
        <div>
          Замените <strong>http://test.com</strong> в utm-метке на название
          вашего сайта.
        </div>
      </div>

      <div style={{ marginTop: 20 }}>
        Пример разметки рекламных кампаний Яндекс директа:
      </div>
      <div>
        <strong>{`http://test.com/?utm_source=yandex&utm_medium=cpc&utm_campaign={campaign_name}&utm_term={keyword}`}</strong>
      </div>

      <div style={{ marginTop: 20 }}>
        Пример разметки рекламных кампаний MyTarget:
      </div>
      <div>
        <strong>{`http://test.com/?utm_source=mytarget&utm_medium=cpc&utm_campaign={{campaign_name}}&utm_term={{search_phrase}}`}</strong>
      </div>

      <div style={{ marginTop: 20 }}>
        Пример разметки рекламных кампаний Google Ads:
      </div>
      <div>
        <strong>{`http://test.com/?utm_source=google_ads&utm_medium=cpc&utm_campaign={campaignid}&utm_term={keyword}`}</strong>
      </div>

      <div style={{ marginTop: 20 }}>
        Пример разметки рекламных кампаний Вконтакте:
      </div>
      <div>
        <strong>{`http://test.com/?utm_source=vk&utm_medium=cpc&utm_campaign=название_кампании`}</strong>
      </div>

      <div style={{ marginTop: 20 }}>
        <em>Примечание по Вконтакте.</em>
      </div>
      <div>
        Значение <strong>название_кампании</strong> нужно заменить на название
        вашей кампании, это необходимо сделать для каждой рекламной кампании.
      </div>

      <div style={{ marginTop: 20 }}>
        Пример разметки рекламных кампаний Facebook:
      </div>
      <div>
        <strong>{`http://test.com/?utm_source=facebook&utm_medium=cpc&utm_campaign=fb_campaign`}</strong>
      </div>

      <div style={{ marginTop: 20 }}>
        <em>Примечание по Facebook. </em>
      </div>
      <div>
        Значение <strong>fb_campaign</strong> нужно заменить на название вашей
        кампании, это необходимо сделать для каждой рекламной кампании.
      </div>

      <h3>Инструменты для быстрого редактирования большого объема utm-меток</h3>
      <ol className={classes.articleList}>
        <li>
          Яндекс - Директ Коммандер{' '}
          <a
            href="https://yandex.ru/promo/commander/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ads.google.com/intl/ru_ru/home/tools/ads-editor/
          </a>
        </li>
        <li>
          Google ads - Редактор google рекламы{' '}
          <a
            href="https://ads.google.com/intl/ru_ru/home/tools/ads-editor/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ads.google.com/intl/ru_ru/home/tools/ads-editor/
          </a>
        </li>
      </ol>
    </article>
  )
}

export default style(RazmetkaUtmMetok)
